/**
 * Affiliations Module
 */
 import Vue from 'vue';
 import router from '../../../router/router';
 import { apiModel, makeApiRequest } from "../../../api";
 import {store} from "../../store";
 
 // States
 const state = {
     messages: [],
     message: {}
 };
 
 // Getters
 const getters = {
    messages: state => {
         return state.messages
     },
 
     message: state => {
         return state.message
     }
 };
 
 // Actions
 const actions = {
     getMessages(context, payload) {
         function successCallback(response) {
             context.commit('getMessagesHandler', { messages: response.data });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.List, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     getMessage(context, payload) {
         function successCallback(response) {
             context.commit('getMessageHandler', { message: response.data.message });
         }
 
         function errorCallback(error) {
 
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Get, localToken, successCallback, errorCallback, payload.errorMessages);
 
     },
 
     createMessage(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
 
             router.push({ name: 'chats', params: { chats: response.data.message.slug } });
         }
 
         function errorCallback(error) {
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Create, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     updateMessage(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             store.dispatch('findAndRemove', {name: 'message' });
             router.push({ name: 'chats', params: { chat: response.data.message.slug } });
 
         }
 
         function errorCallback(error) {
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Update, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 
     deleteMessage(context, payload) {
         function successCallback(response) {
             Vue.swal(
                 payload.successMessage,
                 '',
                 'success'
             );
             store.dispatch('findAndRemove', {name: 'assistant' });
             router.push({ name: 'chats' });
 
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
 
         makeApiRequest(payload.args, apiModel.Message.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
     },
 };
 
 // Mutations
 const mutations = {
     getMessagesHandler(state, { messages }) {
         // Update affiliations state
         state.messages = messages;
     },
 
     getMessageHandler(state, { message }) {
         // Update affiliation state
        //  console.log("message =>", message);
         state.message = message;
     },
 
 };
 
 export default {
     state,
     getters,
     actions,
     mutations
 }